import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallet1"><Path d="M2.5 7.5V4.5H21.5V7.5M2.5 7.5H21.5M2.5 7.5V10.5M21.5 7.5V10.5M21.5 10.5V19.5H2.5V10.5M21.5 10.5L15.5 10.5V13.5H8.5V10.5L2.5 10.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconWallet1;
